// extracted by mini-css-extract-plugin
export default {"header":"LuLMMD7jMvdGRvHpLMU8","icon":"mp2602nYHTQxu9ittt3U","title":"bzAhobzt4TAEE9ZmqUxg","bounce":"p4s0f3jveIGPZhaJpCOp"};